import React from "react";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import {CompanyModelForList} from "../../../../../dictionaries/models/company";
import {CompanyService} from "../../../../../dictionaries/services/companyService";
import i18n from "../../../../../i18n/i18n";
import {ITicketStore} from "../../../../stores/ticketStore";
import {DropDownUtils} from "../../../../../helpers/dropDownUtils";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";

interface TransportationSectionState {
    companies: CompanyModelForList[];
    companiesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class TransportationSection extends React.Component <any, TransportationSectionState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            companies: [],
            companiesResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getCompanies();
    }

    render() {
        const ticketStore = this.context.ticketStore as ITicketStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.ticket.details.transportation.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.ticket.details.transportation.properties.trailerRegNo")}
                            validatedValue={ticketStore.trailerRegNo}
                            testId="trailer-reg-no"
                            offAutocomplete
                        />
                        <DropDown
                            className="element"
                            label={i18n.t("transportation.ticket.details.transportation.properties.transportCompany")}
                            items={this.transportCompanyToDropdown()}
                            validatedValue={ticketStore.transportCompanyId}
                            testId="transport-company"
                            withEmptyValue
                            isLoader={this.state.companies.length < 0}
                            error={!Api.isSuccess(this.state.companiesResponse) ? i18n.t("errorMessages.companiesErrorSuffix") : ""}
                            reloadFunc={() => this.getCompanies()}
                            isNoRequired
                        />
                        <TextInput
                            label={i18n.t("transportation.ticket.details.transportation.properties.lorryRegNo")}
                            validatedValue={ticketStore.lorryRegNo}
                            testId="lorry-reg-no"
                            offAutocomplete
                        />
                    </Row>
                </div>
            </div>
        );
    }

    private transportCompanyToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.companies);
    }

    private async getCompanies() {
        const companiesResponse = await CompanyService.getAll();

        this.setState({
            companies: (companiesResponse)?.data?.data || [],
            companiesResponse
        });
    }
}